import { merge } from '../../../../util/index';
import { Attributes, Http, Resource } from '../../../models/index';
import { SaveResource } from '../SaveResource';

export class SaveAttributesResource<
    T extends Resource<string> & Attributes<any>
> extends SaveResource<T> {
    constructor(http: Http) {
        super(http);
    }

    execute({ resource, updates }: SaveResource.Params<T>): Promise<T> {
        if (updates && updates.attributes) {
            updates.attributes = merge.recursive({}, resource.attributes, updates.attributes);
        }

        return super
            .execute({
                resource,
                updates
            })
            .then((resource) => resource!);
    }
}
